import styled from 'styled-components'

export const InitialStatus = styled.p`
  color: ${({ alertOn }) => alertOn ? '#eb1a21' : 'black'};
  font-weight: ${({ alertOn }) => alertOn ? 'var(--font-weight-semibold)' : 'var(--font-weight-regular)'};
`
